export default "__VITE_ASSET__stQtI21y__"